import { createBreakpoints } from '../utils/createBreakpoints';
const breakpoints = createBreakpoints({});
// ----------------------------------------------------------------------
export const remToPx = (value) => {
    return Math.round(parseFloat(value) * 16);
};
export const pxToRem = (value) => {
    return `${value / 16}rem`;
};
export const responsiveFontSizes = ({ sm, md, lg }) => {
    return {
        [breakpoints.up('sm')]: { fontSize: pxToRem(sm) },
        [breakpoints.up('md')]: { fontSize: pxToRem(md) },
        [breakpoints.up('lg')]: { fontSize: pxToRem(lg) }
    };
};
//# sourceMappingURL=formatFontSize.js.map